import React, {useEffect, useMemo, useState} from "react"
import {Layout, Typography} from 'antd';
import {Link} from "react-router-dom";
import {useAuth} from "../../../providers/AuthProvider";
import ExpandableHtmlText from "../../../components/ExpandableHtmlText";
import {useLocation} from "react-use";
import useBottomVisibility from "../../../hooks/useBottomVisibility";

const {Text} = Typography;
const {Sider } = Layout;

const AgencyProfileDetails = ({agency,shouldMinimizeContent, isVisible, onVisible}) => {
    const {auth} = useAuth();
    const [isBioOpen, setIsBioOpen] = useState(false);
    const location = useLocation();

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    const {
        containerRef,
        bottomMarkerRef,
        bottomMarkerStyle = {},
        isBottomVisible,
        wasBottomVisibleOnLoad,
        hasCheckedInitialVisibility
    } = useBottomVisibility();

    // Initialize if bottom is visible on load
    useEffect(() => {
        if (hasCheckedInitialVisibility) {
            console.log('InitLoadChange', {isVisible, wasBottomVisibleOnLoad})
            onVisible(wasBottomVisibleOnLoad)
        }
    }, [wasBottomVisibleOnLoad, hasCheckedInitialVisibility]);


    // Send changed when bottom is visible
    useEffect(() => {
        if (hasCheckedInitialVisibility && wasBottomVisibleOnLoad !== isBottomVisible) {
            console.log('AfterLoadChange', {isBottomVisible, isVisible, wasBottomVisibleOnLoad})
            onVisible(isBottomVisible)
        }
    }, [isBottomVisible]);

    // Reset bio to closed after affixed and minimized
    useEffect(() => {
        if (shouldMinimizeContent && isBioOpen) {
            setIsBioOpen(isBioOpen)
        }
    }, [shouldMinimizeContent]);

    const [agencyLocation, setAgencyLocation] = useState(() => agency.location || TB.first(agency.locations || []));

    const [backBtnTitle, redirectTo] = useMemo(() => {
        let path = location?.pathname || '';
        let title = 'Go Back';
        let redirect = {
            search: location?.search || '',
            pathname: path.substring(0, path.indexOf('/agency-profiles')) || '/'
        }

        if (!redirect.pathname.length || path.indexOf('/agency-profiles') === 0) {
            const canGoBack = window.history.length > 1 && TB.isDefined(location?.key);
            redirect = !canGoBack ? TB.auth().appropriate() : -1
        }

        if (location.state?.usr?.from) {
            redirect = location.state.usr.from;
        }


        // else if (TB.auth().InitIntended?.pathname !== location.pathname) {
        //     redirect = -1;
        // }

        return [title,redirect]
    }, [location.pathname]);


    return (
        <Sider
            trigger={null}
            collapsible
            collapsed={isSidebarCollapsed}
            width={448}
            collapsedWidth={190}
            className="bg-transparent"
        >
            <div ref={containerRef} className="bg-white pt-12 px-4 pb-6 drop-shadow-md">

                <div className="absolute left-4 top-0 flex flex-row items-center gap-2">
                    <Link to={redirectTo} className="btn btn-link text-[#323C47] hover:text-[#1A1F25] focus:text-[#1A1F25] no-underline py-0 h-12 gap-1 flex flex-row items-center">
                        <i className="fas fa-chevron-left"/>
                        <span>
                            {backBtnTitle}
                        </span>
                    </Link>
                </div>

                <div>
                    <div className="flex justify-between relative">

                        <div className={TB.mapClass("flex items-center", {
                            "gap-4": !shouldMinimizeContent && !isSidebarCollapsed,
                            "gap-2": shouldMinimizeContent || isSidebarCollapsed,
                            "mb-3": !shouldMinimizeContent,
                            "flex-col": isSidebarCollapsed,
                        })}>

                            <div className="relative transition-[width] delay-150">
                                <img src={agency.logo_path} alt={agency.name}
                                     className={TB.mapClass("w-2 mx-auto img-fluid  rounded-full", {
                                         "min-w-28 min-h-28 w-28 h-28": !(isSidebarCollapsed || shouldMinimizeContent),
                                         "min-w-24 min-h-24 w-24 h-24 mb-3": (isSidebarCollapsed || shouldMinimizeContent),
                                     })}/>
                                {/*<Image*/}
                                {/*    className="img-grayscale mx-auto img-fluid transition-all"*/}
                                {/*   */}
                                {/*    hideTooltip*/}
                                {/*    size={(isSidebarCollapsed || shouldMinimizeContent) ? 100 : 128}/>*/}
                            </div>

                            <div className="flex flex-col items-start justify-between gap-1">

                                <p className={TB.mapClass("font-bold", {
                                    "text-lg": !shouldMinimizeContent && !isSidebarCollapsed,
                                    "text-base": shouldMinimizeContent || isSidebarCollapsed,
                                })}>
                                    {agency.name}
                                </p>
                                {!isSidebarCollapsed && (
                                    <React.Fragment>


                                        {agencyLocation && (
                                            <div className="flex items-center gap-2">
                                                <i className="fas fa-map-marker-alt"/>
                                                <p className="text-xs leading-4 text-wrippleBlueGray">{agencyLocation.city}{!!agencyLocation.state && `, ${agencyLocation.state}`}</p>
                                            </div>
                                        )}
                                        <div className="flex flex-col items-stretch gap-1">
                                            <Text type="secondary" className="text-xs">
                                                {agency.sizeName()}
                                            </Text>
                                            <Link className="text-xs btn-link btn-link-primary" to={agency.website}
                                                  target="_blank">
                                                {agency.website}
                                            </Link>
                                        </div>
                                        {/*<div className={TB.mapClass("relative", {*/}
                                        {/*    "flex flex-row items-center gap-2": shouldMinimizeContent,*/}
                                        {/*    "flex flex-col items-start gap-1": !shouldMinimizeContent,*/}
                                        {/*})}>*/}
                                        {/*    <div>*/}
                                        {/*        <div id="commitment-level"*/}
                                        {/*             className="mt-auto py-1 px-2.5 inline-block bg-wripplePrimaryRuleBlue cursor-default">*/}
                                        {/*            <p className="text-xs">{CommitmentOptions[talent.talent_commitment_level]?.title}</p>*/}
                                        {/*        </div>*/}

                                        {/*        <InfoTooltip target="commitment-level" type="dark" placement="bottom">*/}
                                        {/*            <p className="text-white p-0 text-xs">*/}
                                        {/*                {CommitmentOptions[talent.talent_commitment_level]?.description}*/}
                                        {/*            </p>*/}
                                        {/*        </InfoTooltip>*/}
                                        {/*    </div>*/}
                                        {/*    {(talent.displayed_resume_path || talent.linkedin_profile_url) && (*/}
                                        {/*        <div>*/}
                                        {/*            <div className="flex gap-2.5 items-center flex-row justifycenter">*/}
                                        {/*                {talent.linkedin_profile_url && (*/}
                                        {/*                    <a href={talent.linkedin_profile_url} id="pl-linkedin" target="_blank">*/}
                                        {/*                        <i className="fab fa-linkedin text-xl" />*/}
                                        {/*                    </a>*/}
                                        {/*                )}*/}
                                        {/*                {talent.displayed_resume_path && (*/}
                                        {/*                    <a href={talent.displayed_resume_path} id="pl-resume" target="_blank">*/}
                                        {/*                        <i className="fas fa-file-alt text-xl" />*/}
                                        {/*                    </a>*/}
                                        {/*                )}*/}
                                        {/*            </div>*/}
                                        {/*            {talent.linkedin_profile_url && (*/}
                                        {/*                <InfoTooltip target="pl-linkedin" type="dark" placement="bottom">*/}
                                        {/*                    <p className="text-white p-0">*/}
                                        {/*                        Visit LinkedIn Profile*/}
                                        {/*                    </p>*/}
                                        {/*                </InfoTooltip>*/}
                                        {/*            )}*/}
                                        {/*            {talent.displayed_resume_path && (*/}
                                        {/*                <InfoTooltip target="pl-resume" type="dark" placement="bottom">*/}
                                        {/*                    <p className="text-white p-0">*/}
                                        {/*                        Download Resume*/}
                                        {/*                    </p>*/}
                                        {/*                </InfoTooltip>*/}
                                        {/*            )}*/}
                                        {/*        </div>*/}
                                        {/*    )}*/}
                                        {/*</div>*/}
                                    </React.Fragment>
                                )}
                            </div>
                        </div>


                        <button
                            type="button"
                            className="btn-outline bg-wrippleOffWhite h-6 w-6 ml-auto shrink-0 flex items-center justify-center"
                            onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                        >
                            <i className={TB.mapClass("fa fa-chevron-left transition text-base", {'rotate-180': isSidebarCollapsed})}/>
                        </button>


                        {/*<div className={TB.mapClass("absolute bottom-0 left-0 transition", {'opacity-0 invisible': !isSidebarCollapsed})}>*/}
                        {/*    <p className="text-lg font-bold">{talent.firstNamePlusInitial()}</p>*/}
                        {/*</div>*/}
                    </div>

                    <div className={TB.mapClass("transition-all duration-75", {'opacity-0 invisible h-0': isSidebarCollapsed})}>
                        <div
                            className={TB.mapClass("flex flex-col gap-4 transition-all delay-150", {'opacity-0 invisible': isSidebarCollapsed})}>

                            <div>

                                <div className="flex items-end gap-3">
                                    <ExpandableHtmlText
                                        shouldExpand={isBioOpen}
                                        onChange={setIsBioOpen}
                                        showReadMore={false}
                                        content={TB.stripHtml(agency.about)?.length > 0 ? agency.about : '<i>No About Provided</i>'}
                                        maxHeight={350}>
                                        <button
                                            type="button"
                                            className="btn-outline bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center"
                                            onClick={() => {
                                                const visible = !isBioOpen;
                                                setIsBioOpen(!isBioOpen)
                                                onVisible(visible)
                                            }}
                                        >
                                            <i className={TB.mapClass("fa fa-chevron-down transition text-base", {'rotate-180': isBioOpen})}/>
                                        </button>
                                    </ExpandableHtmlText>
                                    {/*<p*/}
                                    {/*    className={TB.mapClass("text-xs text-ellipsis overflow-hidden", {*/}
                                    {/*        '': isBioOpen,*/}
                                    {/*        'line-clamp-6': !isBioOpen,*/}
                                    {/*    })}*/}
                                    {/*>*/}
                                    {/*    {agency.about}*/}
                                    {/*</p>*/}


                                </div>
                            </div>


                            {/*<div>*/}
                            {/*    <p className="text-base font-medium pb-2">Roles</p>*/}

                            {/*    <div className="flex gap-4 flex-wrap">*/}
                            {/*        /!*{TB.map(visibleTalentDisciplines, discipline => (*!/*/}
                            {/*        /!*    <div key={discipline.id}*!/*/}
                            {/*        /!*         className="text-center border border-secondary rounded-lg p-2 pb-1">*!/*/}
                            {/*        /!*        <p className="text-xs font-bold">{discipline.name}</p>*!/*/}
                            {/*        /!*        {!shouldMinimizeContent && (*!/*/}
                            {/*        /!*            <p className="text-xxs text-[#3E3F42]">{scoringOptions[discipline.self_score]}</p>*!/*/}
                            {/*        /!*        )}*!/*/}
                            {/*        /!*    </div>*!/*/}
                            {/*        /!*))}*!/*/}

                            {/*        /!*{!shouldMinimizeContent && !isRolesOpen && (talent.talent_disciplines.length - 4) > 0 && (*!/*/}
                            {/*        /!*    <button*!/*/}
                            {/*        /!*        type="button"*!/*/}
                            {/*        /!*        onClick={() => setIsRolesOpen(!isRolesOpen)}*!/*/}
                            {/*        /!*        className="text-center border border-secondary flex items-center justify-center rounded-lg py-2 px-5"*!/*/}
                            {/*        /!*    >*!/*/}
                            {/*        /!*        <p className="text-xs font-bold">+ {talent.talent_disciplines.length - 4}</p>*!/*/}
                            {/*        /!*    </button>*!/*/}
                            {/*        /!*)}*!/*/}
                            {/*        /!*{shouldMinimizeContent && (talent.talent_disciplines.length - 4) > 0 && (*!/*/}
                            {/*        /!*    <p*!/*/}
                            {/*        /!*        className="text-xxs mr-auto text-left self-center"*!/*/}
                            {/*        /!*    >*!/*/}
                            {/*        /!*        (+ {talent.talent_disciplines.length - 4} more)*!/*/}
                            {/*        /!*    </p>*!/*/}
                            {/*        /!*)}*!/*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            {agency.profile_links?.length > 0 && (
                                <div>
                                    <p className="text-base font-medium pb-2">Links</p>

                                    <div className="flex flex-col items-stretch gap-1.5">
                                        {TB.map(agency.profile_links, (link, index) => {
                                            if (!link.type_icon) {
                                                return null;
                                            }
                                            return (
                                                <div className="flex flex-row flex-nowrap items-center gap-1.5 overflow-x-hidden"
                                                     key={`profile-links-${index}`}>
                                                    <i className={TB.mapClass(`text-sm fa-${link.type_icon}`, {
                                                        "fab": link.type_icon.includes('fa-brand'),
                                                        "fas": !link.type_icon.includes('fa-brand')
                                                    })} style={{color: link.type_color || '#000'}}/>
                                                    <Link to={link.url} target="_blank"
                                                          className="text-xs hover:underline text-info hover:font-medium truncate flex-grow">
                                                        {link.url}
                                                </Link>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>

                            )}

                        </div>
                    </div>
                </div>

                {/* Bottom ref to check that entire content has been seen */}
                <div
                    ref={bottomMarkerRef}
                    className="absolute bottom-0 left-0 w-full h-[0.05rem]"
                    style={bottomMarkerStyle}
                />
            </div>
        </Sider>
    )
}

export default AgencyProfileDetails;